export enum FiltroLog {
  Todos = 0,
  Por_Data = 1,
  Por_Id_do_Usuario = 2,
  Por_Nome_do_Usuario = 3,
  Por_Descrição = 4
}
